import { LandingPage } from "core/pages";

export default LandingPage;
